import {
    MEMBER_GET_SUMMARY,
    MEMBER_GET_FLATS,
    MEMBER_GET_INVOICES,
    MEMBER_GET_INVOICE_DETAILS,
    MEMBER_GET_PAYMENTS,
    MEMBER_GET_PAYMENT_DETAILS,
    MEMBER_GET_LEDGER,
    MEMBER_GET_COMPLAINTS,
    MEMBER_GET_COMPLAINT_DETAILS,
    MEMBER_GET_COMPLAINT_ENUMS,
    MEMBER_CREATE_COMPLAINT,
    MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS,
    MEMBER_ADD_COMPLAINT_COMMENT,
    MEMBER_RATE_COMPLAINT,
} from '../../index.types';

export const getMemberSummary = (data) => ({ type: MEMBER_GET_SUMMARY, data });
export const getMemberFlats = (data) => ({ type: MEMBER_GET_FLATS, data });
export const getMemberInvoices = (data) => ({ type: MEMBER_GET_INVOICES, data });
export const getMemberInvoiceDetails = (data) => ({ type: MEMBER_GET_INVOICE_DETAILS, data });
export const getMemberPayments = (data) => ({ type: MEMBER_GET_PAYMENTS, data });
export const getMemberPaymentDetails = (data) => ({ type: MEMBER_GET_PAYMENT_DETAILS, data });
export const getMemberLedger = (data) => ({ type: MEMBER_GET_LEDGER, data });

// Resident complaints — the whole flow lives on /api/member/complaints*, so a
// role holding only member_portal.complaints can list, raise, attach, comment
// and rate. Write actions accept onSuccess(result) like the Complaint slice.
export const getMemberComplaints = (data) => ({ type: MEMBER_GET_COMPLAINTS, data });
export const getMemberComplaintDetails = (data) => ({ type: MEMBER_GET_COMPLAINT_DETAILS, data });
export const getMemberComplaintEnums = (data) => ({ type: MEMBER_GET_COMPLAINT_ENUMS, data });
export const createMemberComplaint = (data) => ({ type: MEMBER_CREATE_COMPLAINT, data });
export const uploadMemberComplaintAttachments = (data) => ({ type: MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS, data });
export const addMemberComplaintComment = (data) => ({ type: MEMBER_ADD_COMPLAINT_COMMENT, data });
export const rateMemberComplaint = (data) => ({ type: MEMBER_RATE_COMPLAINT, data });
